import './App.css';
import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { FooterProvider, useFooter } from "./components/FooterContext";
import Footer from "./components/Footer";
import ImageRatingComponent from './components/ImageRatingComponent';
import ImageFreeComponent from './components/ImageFreeComponent';
import WelcomeComponent from './components/WelcomeComponent';
import TutorialComponent from './components/TutorialComponent';


import { getUUID } from './components/ImageRating/api';

// Timer importieren
import createTimer from './components/ImageRating/Timer';

function App() {
  const [data, setData] = useState([{}])
  const [debugging, setDebugging] = useState(true);
  // Timer-Instanz erstellen
  const timerRef = useRef(createTimer()).current;

  useEffect(() => {
    fetch("https://genfashioneeg.medien.ifi.lmu.de/api/members")
      .then(response => response.json())
      .then(data => console.log(data))
      .catch(error => console.error("Error fetching data:", error));
    setData(data);
  }, []);

  const [uuid, setUuid] = useState(null);
  let hasRequestedUUID = false;

  useEffect(() => {
    if (hasRequestedUUID) return;
    hasRequestedUUID = true;

    const qp = new URLSearchParams(window.location.search);
    const uuidParam = qp.get("uuid");
    if (uuidParam) {
      setUuid(uuidParam);
      return;
    }
    getUUID()
      .then(data => {
        setUuid(data.uuid);
        window.location.href =
          `${window.location.origin}${window.location.pathname}?uuid=${data.uuid}&taskid=1&iteration=0`;
      })
      .catch(err => console.error("Error fetching UUID:", err));
  }, []);


  return (
    <div className="App">
      <div className="App-Header">
        <strong>AI-Dress Designer: Couture Revée</strong>
      </div>
      <FooterProvider>
        <Router>
          <Routes>
            <Route path="/" element={
              <WelcomeComponent  uuid={uuid} debugging={debugging}/>
            } />
            <Route path="/tutorial" element={
              <TutorialComponent uuid={uuid} debugging={debugging}/>
            } />
            <Route path="/rating" element={
              <ImageRatingComponent timer={timerRef} uuid={uuid} debugging={debugging} tutorial={false} />
            } />
            <Route path="/free" element={
              <ImageFreeComponent timer={timerRef} uuid={uuid} debugging={debugging} />
            } />
          </Routes>
        </Router>
        <Footer debugging={debugging} />
    </FooterProvider>
    </div>
  );
}

export default App;